module.exports = __webpack_public_path__ + "img/portrait_JJLin.0fec92a7.jpg";